import { z } from 'zod';

const LeaderboardItemSchema = z.object({
  place: z.number(),
  userId: z.number(),
  points: z.number()
});

export const LeaderboardResponseSchema = z.object({
  status: z.enum(['success', 'error']),
  data: z.object({
    leaderboard: z.array(LeaderboardItemSchema),
    participant: z.boolean(),
    qualified: z.boolean(),
    qualificationProgress: z.object({
      bets: z.number().nullable(),
      qualificationBets: z.number().nullable(),
      potentialPoints: z.number().nullable()
    })
  })
});
